(function () {
  'use strict';

  var FORM_SELECTOR = 'form.cdl-listing-atc-form';
  var BUTTON_SELECTOR = '.cdl-listing-cta';

  function shopifyUrl(path) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + path.replace(/^\//, '');
  }

  function responseJson(response) {
    return response.json().catch(function () {
      return {};
    }).then(function (body) {
      if (!response.ok) {
        throw new Error(body.description || body.message || 'Error ' + response.status);
      }

      return body;
    });
  }

  function updateCartCount(count) {
    document.querySelectorAll('.cart-count').forEach(function (element) {
      var hasParentheses = /^\s*\(.*\)\s*$/.test(element.textContent || '');
      element.textContent = hasParentheses ? '(' + count + ')' : String(count);
    });

    document.querySelectorAll('.cart-count-ajax').forEach(function (element) {
      element.textContent = String(count);
    });
  }

  function restoreButton(button, label, disabled, delay) {
    window.setTimeout(function () {
      button.textContent = label;
      button.disabled = disabled;
      button.removeAttribute('aria-live');
    }, delay);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!form.matches || !form.matches(FORM_SELECTOR)) return;
    if (!window.fetch || !window.FormData) return;

    event.preventDefault();

    if (form.dataset.cdlCartSubmitting === 'true') return;

    var button = form.querySelector(BUTTON_SELECTOR);
    if (!button) {
      form.submit();
      return;
    }

    var originalLabel = button.textContent.trim();
    var originallyDisabled = button.disabled;

    form.dataset.cdlCartSubmitting = 'true';
    button.disabled = true;
    button.setAttribute('aria-live', 'polite');
    button.textContent = 'Agregando…';

    fetch(shopifyUrl('cart/add.js'), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: new FormData(form)
    })
      .then(responseJson)
      .then(function (item) {
        return fetch(shopifyUrl('cart.js'), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin'
        }).then(responseJson).then(function (cart) {
          updateCartCount(cart.item_count);
          button.textContent = 'Agregado';
          document.dispatchEvent(new CustomEvent('cdl:cart:added', {
            detail: { item: item, cart: cart, form: form }
          }));
          restoreButton(button, originalLabel, originallyDisabled, 1200);
        });
      })
      .catch(function (error) {
        console.error('No se pudo agregar el producto al carrito.', error);
        button.textContent = 'No se pudo agregar';
        document.dispatchEvent(new CustomEvent('cdl:cart:error', {
          detail: { error: error, form: form }
        }));
        restoreButton(button, originalLabel, originallyDisabled, 2200);
      })
      .then(function () {
        delete form.dataset.cdlCartSubmitting;
      });
  }, true);
})();
